import { useEffect } from 'react';

import { TableInstance } from 'react-table';
import { usePrevious } from '@bringg-frontend/hooks';

import { TableConfigObjectAdapter } from 'bringg-web/stores/alerts-view/table-config-object-adapter';

const usePresetViewStateChangedEffect = <T extends Record<string, unknown>>(
	tableConfig: TableConfigObjectAdapter,
	tableInstance: TableInstance<T>
) => {
	const prevPresetEdited = usePrevious(tableConfig.activePreset?.edited);
	const prevPresetId = usePrevious(tableConfig.activePreset?.id);

	// this check is needed for 'uncontrolled' table config which is not set by useControlledTableState
	const presetWasChanged =
		prevPresetId !== tableConfig.activePreset?.id ||
		(prevPresetEdited === true && tableConfig.activePreset?.edited === false);

	useEffect(() => {
		if (presetWasChanged) {
			tableInstance.setSortBy(tableConfig.tableSortBy);
			tableInstance.setColumnWidths(tableConfig.tableColumnWidths);
		}
	}, [presetWasChanged]);
};

export default usePresetViewStateChangedEffect;
